<script setup>
import { Link } from '@inertiajs/vue3';

defineProps({
  href: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <Link
    :href="href"
    class="block w-full px-4 py-2 text-sm leading-5 text-grey-700 transition duration-fast ease-in-out text-start dark:text-grey-300 hover:bg-grey-100 dark:hover:bg-grey-700 focus:outline-none focus:bg-grey-100 dark:focus:bg-grey-700"
  >
    <slot />
  </Link>
</template>
